import { useRecords } from '@/shared/hooks/useRecords'

import type { Media } from '@/types/media'

export interface TopLikedPartner {
  id: number
  name: string
  slug: string
  logo: Media | null
}

/**
 * RF-13: destaque de parceiros por reação quando o motor não encontrou nada em
 * comum. `top_likes` devolve só ids (contagem de curtidas no servidor, sem
 * paginação) — os registros completos são buscados filtrando por `id_in` via
 * ransack (`params[:q]`, `base_controller#index_scope`), em vez de paginar o
 * índice inteiro de parceiros e filtrar no cliente, o que perderia parceiros
 * fora da primeira página.
 */
export const useTopLikedPartners = (
  digitalProductId: string | number | null | undefined
): { partners: TopLikedPartner[]; isLoading: boolean } => {
  const basePath = digitalProductId
    ? `/user/digital_products/${digitalProductId}/partners`
    : ''

  const { records: topLikeIds, isLoading: isLoadingIds } = useRecords({
    r: basePath ? `${basePath}/top_likes` : '',
    shouldFetch: !!basePath
  }) as { records: number[]; isLoading: boolean }

  const hasIds = topLikeIds.length > 0

  const { records: partners, isLoading: isLoadingPartners } = useRecords({
    r: basePath,
    params: { q: { id_in: topLikeIds } },
    shouldFetch: hasIds
  }) as { records: TopLikedPartner[]; isLoading: boolean }

  return {
    partners: hasIds ? partners : [],
    isLoading: isLoadingIds || (hasIds && isLoadingPartners)
  }
}
